import type { ReactNode } from 'react';

import { Box } from '@mui/material';

import { normalizeSx } from '@/shared/lib/normalizeSx';
import type { Sx } from '@/shared/types/uiTypes';

export const InfoBox = ({
  children,
  backgroundColor,
  sx
}: {
  children?: ReactNode;
  sx?: Sx;
  backgroundColor?: string;
}) => {
  return (
    <Box
      sx={[
        theme => ({
          backgroundColor: backgroundColor ?? theme.palette.gx.tileLight,
          color: theme.palette.gx.text,
          borderLeft: `4px solid ${theme.palette.gx.highlight}`
        }),
        ...normalizeSx(sx)
      ]}
    >
      {children}
    </Box>
  );
};
